export const hublotDrawer = {
  groups: [
    {id: 1, title: 'Accueil', icon: 'home', type: 'common'},
    {id: 2, title: 'Gestion', icon: 'equalizer', type: 'shop'},
    {id: 3, title: 'Commerce', icon: 'shopping_cart', type: 'shop'},
    {id: 4, title: 'Législation', icon: 'balance', type: 'common'},
    {id: 5, title: 'Infos', icon: 'contact_support', type: 'common'}
  ],
  links: [
    //   { title: 'Home', to: '/', icon: 'dashboard' },
    // { title: 'Accueil', to: '/', icon: 'dashboard' },
    {title: 'Checklist', to: '/home', icon: 'check', idGroup: 1},
    {title: 'Changement de prix', to: '/price', icon: 'trending_up', idGroup: 2},
    {title: 'Hygiène', to: '/hygiene', icon: 'icon-droplet', idGroup: 4},
    {
      title: 'Nettoyage du mois',
      to: '/nettoyages',
      icon: 'wash',
      idGroup: 4
    },
    {
      title: 'Objectifs',
      to: '/objectifs',
      icon: 'icon-gestion1',
      idGroup: 2
    },
    {
      title: 'Températures du mois',
      to: '/temperatures',
      icon: 'thermostat',
      idGroup: 4
    },
    {
      title: 'Traçabilité',
      to: '/tracabilite',
      icon: 'picture_in_picture',
      idGroup: 4
    },
    {
      title: 'Recettes',
      to: '/recettes',
      icon: 'format_list_numbered_rtl',
      idGroup: 4
    },
    {title: 'Commandes client', to: '/commandes', icon: 'portrait', idGroup: 3},
    {
      title: 'Remarques client',
      to: '/remarques',
      icon: 'record_voice_over',
      idGroup: 3
    },
    {title: 'Étiquettes prix', to: '/etiquettes', icon: 'local_offer', idGroup: 3},
    {title: 'Achats', to: '/achats', icon: 'add_shopping_cart', idGroup: 2},
    {title: 'Simulateur', to: '/simulateur', icon: 'icon-calculator', idGroup: 2},
    {title: 'Mail', to: '/mail', icon: 'mail', idGroup: 5},
    {title: 'Mises à jour Hublot', to: '/backlog', icon: 'info', idGroup: 5},
    {title: 'Intégration', to: '/integration', icon: 'publish', idGroup: 5}

    // { title: 'Commandes Fournisseur', to: '/fournisseur', icon: 'local_shipping' },
  ]
}

export const carnotDrawer = {
  groups: [
    {id: 1, title: 'Gestion', icon: 'equalizer', type: 'common'},
    {id: 2, title: 'Commerce', icon: 'shopping_cart', type: 'common'},
    {id: 3, title: 'Législation', icon: 'balance', type: 'common'},
    {id: 4, title: 'Infos', icon: 'contact_support', type: 'common'}
  ],
  links: [
    {
      title: 'Traçabilité',
      to: '/tracabilite',
      icon: 'picture_in_picture',
      idGroup: 3
    },
    {
      title: 'Températures du mois',
      to: '/temperatures',
      icon: 'thermostat',
      idGroup: 3
    },
    {
      title: 'Nettoyage du mois',
      to: '/nettoyages',
      icon: 'wash',
      idGroup: 3
    },
    {
      title: 'Hygiène',
      to: '/hygiene',
      icon: 'icon-droplet',
      idGroup: 3
    },
    {
      title: 'Commandes client',
      to: '/commandes',
      icon: 'portrait',
      idGroup: 2
    },
    {
      title: 'Objectifs',
      to: '/objectifs',
      icon: 'icon-gestion1',
      idGroup: 1
    },
    {
      title: 'Rendements',
      to: '/rendements',
      idGroup: 1,
      icon: 'icon-gestion2'
    },
    {
      title: 'Achats',
      to: '/tableauAchats',
      icon: 'add_shopping_cart',
      idGroup: 1
    },
    {title: 'Intégration', to: '/integration', icon: 'publish', idGroup: 4}
  ]
}
